import { Card as MuiCard } from '@material-ui/core'
import styled from 'styled-components'

export const RewardsCard = styled(MuiCard)`
  background-color: ${({ theme }) => theme.colors.brand.white};
  padding: 24px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  box-shadow: none;

  @media (min-width: 1024px) {
    padding: 32px;
  }
`

export const RewardsCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (min-width: 1280px) {
    flex-direction: row;
    gap: unset;
  }
`

export const RewardsCardSubHeader = styled.div`
  display: flex;
  align-items: baseline;
`
